// Shared wishlist data layer used across the header badge, product/collection
// card hearts, and the standalone wishlist page. Single source of truth so
// all three stay in sync and share one storage schema.
//
// Schema: localStorage['maemae_wishlist'] = [{ handle: 'foo', qty: 1 }, ...]
// Older versions stored a flat array of handle strings; normalize() upgrades
// those transparently the first time they're read, so nobody's saved
// wishlist gets wiped by this change.
(function (global) {
  var KEY = 'maemae_wishlist';

  function normalize(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (item) {
        if (typeof item === 'string') return { handle: item, qty: 1 };
        if (item && typeof item === 'object' && item.handle) {
          var qty = parseInt(item.qty, 10);
          return { handle: item.handle, qty: qty > 0 ? qty : 1 };
        }
        return null;
      })
      .filter(Boolean);
  }

  function getAll() {
    try {
      return normalize(JSON.parse(localStorage.getItem(KEY) || '[]'));
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('maemae:wishlist-updated', { detail: { wishlist: list } }));
    updateBadge(list);
  }

  function has(handle) {
    return getAll().some(function (i) {
      return i.handle === handle;
    });
  }

  function getQty(handle) {
    var found = getAll().filter(function (i) {
      return i.handle === handle;
    })[0];
    return found ? found.qty : 0;
  }

  function toggle(handle) {
    var list = getAll();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        idx = i;
        break;
      }
    }
    var nowActive;
    if (idx === -1) {
      list.push({ handle: handle, qty: 1 });
      nowActive = true;
    } else {
      list.splice(idx, 1);
      nowActive = false;
    }
    save(list);
    return nowActive;
  }

  function remove(handle) {
    save(
      getAll().filter(function (i) {
        return i.handle !== handle;
      })
    );
  }

  function setQty(handle, qty) {
    qty = parseInt(qty, 10);
    if (!(qty > 0)) qty = 1;
    var list = getAll();
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        list[i].qty = qty;
        break;
      }
    }
    save(list);
  }

  function totalCount() {
    return getAll().reduce(function (sum, i) {
      return sum + i.qty;
    }, 0);
  }

  function updateBadge(list) {
    var bubble = document.getElementById('wishlist-count-bubble');
    var number = document.getElementById('wishlist-count-number');
    if (!bubble || !number) return;
    var total = (list || getAll()).reduce(function (sum, i) {
      return sum + i.qty;
    }, 0);
    number.textContent = total;
    bubble.classList.toggle('is-visible', total > 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadge();
  });
  document.addEventListener('shopify:section:load', function () {
    updateBadge();
  });

  global.MaemaeWishlist = {
    getAll: getAll,
    has: has,
    getQty: getQty,
    toggle: toggle,
    remove: remove,
    setQty: setQty,
    totalCount: totalCount,
    updateBadge: updateBadge,
  };
})(window);
